import styles from "./MinimalDashboard.module.scss";
import { customStyles } from './customStyles';
// @ts-ignore
import {CSVLink} from 'react-csv';
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import {utils, writeFile} from "xlsx";

import {useState} from 'react';
import {NavLink} from 'react-router-dom';
import * as React from 'react';
import {IData, IDataarray, IDataMetrics,IDataColumns} from "./types";
import {useQuery} from "@apollo/client";
import {ASSESSMENT_RESULTS} from "../../apollo/queries";
import downloadImg from '../../styles/download_icon.png';
import Select from 'react-select';
import {useLazyQuery} from "@apollo/react-hooks";
import DataTable, {TableColumn} from 'react-data-table-component';


enum Routes {
    STARTUPS = '/library/startups',
}

const columns: TableColumn<IDataColumns>[] = [
    {
        name: <div>Venture Scan</div>,
        // @ts-ignore
        selector: row => row.venture,
        format: row => {
            return row.venture_website !== null
                // ? row.logo.charAt(0).toUpperCase() + row.logo.slice(1)
                ?    <a href={row.report_generated} target="_blank" style={{display: 'inline-block', position: 'relative', zIndex: '0',color: 'rgb(0, 116, 118)'}}>
                    <div>{row.venture}</div>
                </a>
                : row.venture
        },
        sortable: true,
        style: {
            minWidth: "200px",
            textAlign:'center',
        }
    },
    {
        name: <div>Website</div>,
        // @ts-ignore
        selector: row => row.venture_website,
        format: row => {
            if(!row.venture_website) return ""
            const link = 'https://logo.clearbit.com/'+ row.venture_website.charAt(0).toUpperCase() + row.venture_website.slice(1)
            return row.venture_website !== null
                // ? row.logo.charAt(0).toUpperCase() + row.logo.slice(1)
                ?    <a href={row.venture_website} target="_blank" style={{display: 'inline-block', position: 'relative', zIndex: '0' ,color: 'rgb(0, 116, 118)'}}>
                    <div style={{display: 'inline-block' }}>
                        <object type="text/html" data={link}  style={{
                            position: 'relative',
                            zIndex: '-1',
                            width: '150px',
                            height: '150px',
                            transformOrigin: '5px 5px',
                            marginBottom: 'calc((0.15 - 1) * 100%)',
                            transform: 'scale(0.15) translate(20%, 0%)'
                        }}>
                            website
                        </object>
                    </div>
                </a>
                : row.venture_website
        },
        sortable: true,
        style: {
            minWidth: "10px",
            textAlign:'center',
        }
    },
    {
        name: <div>Next Milestone</div>,
        // @ts-ignore
        selector: row => row.nextMilestoneCalc,
        sortable: true,
        style: {
            // minWidth: "200px",
            // textAlign:'center',
        }

    },
    {
        name: <div>Consistency Score</div>,
        selector: row => row.consistencyScoreCalc,
        sortable: true,
    },
    {
        name: <div>Sector</div>,
        selector: row => row.sector,
        sortable: true,
    },
    {
        name: 'Age',
        selector: row => row.age_years,
        sortable: true,
    },
    {
        name: 'Employees',
        selector: row => row.number_of_employees,
        sortable: true,
    },
    {
        name: <div>Funding raised</div>,
        selector: row => row.amount_invested,
        sortable: true,
    },
    {
        name: <div>Funding need</div>,
        selector: row => row.amount_invested_need,
        sortable: true,
    },
    {
        name: <div> Date assessment</div>,
        selector: row => row.assessmentDate,
        sortable: true,
    },
];

export const MinimalDashboard = () => {
    const [barChartDataMetrics, setBarChartDataMetrics] = useState<IDataMetrics>();
    const [barChartDataSector, setBarChartDataSector] = useState<IData[]>([]);
    const [barChartDataMilestones, setBarChartDataMilestones] = useState<IDataarray[]>([]);
    const [DataDevBox, setDataDevBox] = useState<IDataarray[]>([]);
    const [dataTable, setDataTable] = useState<IDataColumns[]>([]);
    const [selectObject, setSelectObject] = useState<[{label:string, value: string|number}] | [] | null>([]);
    const [selectClear, setSelectClear] = useState<[{label:string, value: string|number}] | []|null>(null);
    const [selectSector, setSelectSector] = useState<{label:string} | null>(null);
    const [selectActualStage, setSelectActualStage] = useState<{label:string} | null>(null);
    const [dataTagSuggestions, setDataTagSuggestions] = useState<[{label:string, value: string|number}] | []>([]);
    const [dataAssessmentsSuggestions, setDataAssessmentsSuggestions] = useState<[{label:string, value: string|number}] | []>([]);
    const [scanUsage, setScanUsage] = useState<IDataarray[]>([]);
    const [tags, setTags] = useState<{label:string, value: string|number} | null>(null);
    const [toggleFilter, setToggleFilter] = useState(true);
    const [toggleTable, setToggleTable] = useState(true);
    const [toggleMetrics, setToggleMetrics] = useState(true);

    const handleClickFilter = () => {{setToggleFilter(!toggleFilter)}};
    const handleClickTable = () => {{setToggleTable(!toggleTable)}};
    const handleClickMetrics = () => {{setToggleMetrics(!toggleMetrics)}};

    useQuery(ASSESSMENT_RESULTS, {
        variables: {
            assessmentId: null,
            tagId: null,
            sector: null,
            actualStage:null
        },
        onCompleted: (someData) => {
            setBarChartDataMetrics(someData.resultDataframe.portfolioDataMetrics)
            setBarChartDataSector(someData.resultDataframe.companyCountSectors)
            setBarChartDataMilestones(someData.resultDataframe.companyCountMilestones)
            setDataDevBox(someData.resultDataframe.companyDevBox)
            setDataTable(someData.resultDataframe.companyTable)
            setDataTagSuggestions(someData.resultDataframe.tagOptionsResults)
            setDataAssessmentsSuggestions(someData.resultDataframe.assessmentsOptionsResults)
            setScanUsage(someData.resultDataframe.scanUsageResults)

        },
        fetchPolicy: "no-cache"
    });

    const [getAssessmentResults] = useLazyQuery(ASSESSMENT_RESULTS, {
        onCompleted: (someData) => {
            setBarChartDataMetrics(someData.resultDataframe.portfolioDataMetrics)
            setBarChartDataSector(someData.resultDataframe.companyCountSectors)
            setBarChartDataMilestones(someData.resultDataframe.companyCountMilestones)
            setDataDevBox(someData.resultDataframe.companyDevBox)
            setDataTable(someData.resultDataframe.companyTable)
            setScanUsage(someData.resultDataframe.scanUsageResults)
        },
        fetchPolicy: "no-cache"
    });

    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="Data Dashboard" subtitle=""/>
            <div className={styles.flexGrid}>
                <div className={styles.col}>
                    <div>
                        {toggleFilter ?
                            <ul>
                                <button onClick={handleClickFilter}>
                                    <h2><span style={{fontFamily: "consola",fontSize:30,color:"#007476"}}>&minus;</span><span> &nbsp; Filter</span></h2>
                                </button>
                                <div className={styles.flexGridHalfs}>

                                    <div className={styles.col}>
                                        <h4>Select your label:
                                        </h4>
                                        <br/>
                                        {dataTagSuggestions.length > 0 &&
                                            <>
                                                {/*<h5>Select your label:</h5>*/}
                                                <Select options={dataTagSuggestions} closeMenuOnSelect={true} value = {tags}  placeholder='Search and select group of companies by your label...'
                                                        classNamePrefix="select" defaultValue={dataTagSuggestions[0] } onChange={
                                                    // @ts-ignore
                                                    async (e) => {
                                                        setSelectClear(null)
                                                        setSelectSector(null)
                                                        setTags(null)
                                                        setSelectActualStage(null)
                                                        setSelectObject(null)
                                                        setTags(e)
                                                        if (e?.label !== undefined) {
                                                            await getAssessmentResults({
                                                                variables: {
                                                                    assessmentId: null,
                                                                    // @ts-ignore
                                                                    tagId: typeof e.value === 'number' ? e.value : parseInt(e.value),
                                                                    sector: null,
                                                                    actualStage:null
                                                                }
                                                            })
                                                        }
                                                    }
                                                }/>
                                            </>
                                        }
                                        <button className={styles.buttonClearSearch} onClick={
                                            async (e:any) => {
                                                setSelectSector(null)
                                                setTags(null)
                                                setSelectActualStage(null)
                                                setSelectObject(null)
                                                setSelectClear(e)
                                                if (e?.value !== null) {
                                                    await getAssessmentResults({
                                                        variables: {
                                                            assessmentId: null,
                                                            tagId:null,
                                                            sector: null,
                                                            actualStage:null
                                                        }
                                                    })
                                                }
                                            }
                                        }>
                                            Clear filter
                                        </button>
                                    </div>
                                    <div className={styles.col}>
                                        <h4>Explanation:</h4><br/>
                                        {/*The data below is cleaned and updated with the latest version of the algorithm to get optimal data insights.*/}
                                        {/*All the assessments since March 2022 are included. <br/><br/>*/}
                                        Get an overview of your selection of companies.<br/><br/>
                                        Create more labels on the <NavLink to={Routes.STARTUPS}> Library</NavLink> page.<br/><br/>


                                    </div>
                                </div>
                            </ul>
                            :
                            <>
                                 <button onClick={handleClickFilter}>
                                    <h2><span style={{fontFamily: "consola",fontSize:30,color:"#007476"}}>+</span><span> &nbsp; Filter</span></h2>
                                </button>
                            </>
                        }
                    </div>
                </div>
            </div>
            <div className={styles.flexGrid}>
                <div className={styles.col}>
                    {toggleMetrics ?
                        <ul>
                            <button onClick={handleClickMetrics}>
                                <h2><span style={{fontFamily: "consola", fontSize: 30, color: "#007476"}}>&minus;</span><span> &nbsp; Metrics</span>
                                </h2>
                            </button>
                            {barChartDataMetrics &&
                                <div>
                                    {/*<CSVLink data={[barChartDataMetrics]} filename="export-data-metrics">*/}
                                    {/*    <button className={styles.button} style={{float: 'right'}}>*/}
                                    {/*        <img src={downloadImg} style={{float: 'right'}} width={15}/> Download data (csv)*/}
                                    {/*    </button>*/}
                                    {/*</CSVLink>*/}
                                    <button className={styles.button} onClick={() => {
                                        const ws = utils.json_to_sheet(DataDevBox);
                                        const wb = utils.book_new();
                                        utils.book_append_sheet(wb, ws, "SheetJS");
                                        /* generate XLSX file and send to client */
                                        writeFile(wb, "export_data-metrics.xlsx");
                                    }} style={{float: 'right'}}>
                                        <img src={downloadImg} style={{float: 'right'}} width={15}/> Download data
                                    </button>
                                </div>
                    }
                    <div className={styles.flexGridThirds}>
                        <div className={styles.col}>
                            <h2>Companies</h2>
                            <br/>
                            <table width={'100%'}>
                                <tbody>
                                <tr>
                                    <th align={'left'}>
                                        Unique companies:
                                    </th>
                                    <th align={'right'}>
                                        {barChartDataMetrics &&
                                            <b style={{fontSize: 20}}>
                                                        {JSON.stringify(barChartDataMetrics.totalCompanies)}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        <tr>
                                            <th align={'left'}>
                                                Company scans:
                                            </th>
                                            <th align={'right'}>
                                                {barChartDataMetrics &&
                                                    <b style={{fontSize: 20}}>
                                                        {JSON.stringify(barChartDataMetrics.totalScans)}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        <tr>
                                            <th align={'left'}>
                                                Progress scans:
                                            </th>
                                            <th align={'right'}>
                                                {barChartDataMetrics &&
                                                    <b style={{fontSize: 20}}>
                                                        {Number(JSON.stringify(barChartDataMetrics.totalScans)) -
                                                            Number(JSON.stringify(barChartDataMetrics.totalCompanies))}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        <tr>
                                            <th align={'left'}>
                                                Average company age:
                                            </th>
                                            <th align={'right'}>
                                                {barChartDataMetrics &&
                                                    <b style={{fontSize: 20}}>
                                                        {Math.round((
                                                            Number(JSON.stringify(barChartDataMetrics.totalAgeInMonths)) * (10 / 12) /
                                                            Number(JSON.stringify(barChartDataMetrics.totalScans)))
                                                        ) / 10 + ' yrs'}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className={styles.col}>
                                    <h2> Funding</h2>
                                    <br/>
                                    <table width={'100%'}>
                                        <tbody>
                                        <tr>
                                            <th align={'left'}>
                                                Total funding raised:
                                            </th>
                                            <th align={'right'}>
                                                {barChartDataMetrics &&
                                                    <b style={{fontSize: 20}}>
                                                        {'€ ' + Math.round(
                                                            Number(JSON.stringify(barChartDataMetrics.totalAmountInvested)) / 100000
                                                        ) / 10 + ' M'}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        <tr>
                                            <th align={'left'}>
                                                Funding per company:
                                            </th>
                                            <th align={'right'}>
                                                {barChartDataMetrics &&
                                                    <b style={{fontSize: 20}}>
                                                        {'€ ' + Math.round(
                                                            Number(JSON.stringify(barChartDataMetrics.totalAmountInvested)) /
                                                            Number(JSON.stringify(barChartDataMetrics.totalScans)) / 100000
                                                        ) / 10 + ' M'}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        <tr>
                                            <th align={'left'}>
                                                Total funding need:
                                            </th>
                                            <th align={'right'}>
                                                {barChartDataMetrics &&
                                                    <b style={{fontSize: 20}}>
                                                        {'€ ' + Math.round(
                                                            Number(JSON.stringify(barChartDataMetrics.totalAmountInvestedNeed)) / 100000
                                                        ) / 10 + ' M'}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        <tr>
                                            <th align={'left'}>
                                                Funding need per company:
                                            </th>
                                            <th align={'right'}>
                                                {barChartDataMetrics &&
                                                    <b style={{fontSize: 20}}>
                                                        {'€ ' + Math.round(Number(JSON.stringify(barChartDataMetrics.totalAmountInvestedNeed)) /
                                                            Number(JSON.stringify(barChartDataMetrics.totalScans)) / 100000
                                                        ) / 10 + ' M'}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className={styles.col}>
                                    <h2>Employees</h2>
                                    <br/>
                                    <table width={'100%'}>
                                        <tbody>
                                        <tr>
                                            <th align={'left'}>
                                                Total employees:
                                            </th>
                                            <th align={'right'}>
                                                {barChartDataMetrics &&
                                                    <b style={{fontSize: 20}}>
                                                        {JSON.stringify(barChartDataMetrics.totalNumberOfEmployees)}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        <tr>
                                            <th align={'left'}>
                                                Employees per company:
                                            </th>
                                            <th align={'right'}>
                                                {barChartDataMetrics &&
                                                    <b style={{fontSize: 20}}>
                                                        {Math.round(
                                                            Number(JSON.stringify(barChartDataMetrics.totalNumberOfEmployees)) /
                                                            Number(JSON.stringify(barChartDataMetrics.totalScans)) * 10
                                                        ) / 10}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        <tr>
                                            <th align={'left'}>
                                                Serial entrepreneur factor:
                                            </th>
                                            <th align={'right'}>
                                                {barChartDataMetrics &&
                                                    <b style={{fontSize: 20}}>
                                                        {Math.round(
                                                            Number(JSON.stringify(barChartDataMetrics.totalSerialFounder)) /
                                                            Number(JSON.stringify(barChartDataMetrics.totalScans)) * 10
                                                        ) / 10}
                                                    </b>
                                                }
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </ul>
                        :
                        <>
                            <button onClick={handleClickMetrics}>
                                <h2><span style={{fontFamily: "consola",fontSize:30,color:"#007476"}}>+</span><span> &nbsp; Metrics</span></h2>
                            </button>
                        </>
                    }
                </div>
            </div>
            <div className={styles.flexGrid}>
                {DataDevBox &&
                        <div className={styles.tableWrap}>

                        {toggleTable ?
                            <ul>
                                <button onClick={handleClickTable}>
                                    <h2><span style={{fontFamily: "consola",fontSize:30,color:"#007476"}}>&minus;</span><span> &nbsp; Data table of scanned companies</span></h2>
                                </button>
                                {/*<CSVLink data={DataDevBox} filename={"export-datatable"}>*/}
                                {/*    <button className={styles.button} style={{float: 'right'}}>*/}
                                {/*        <img src={downloadImg} style={{float: 'right'}} width={15}/> Download data (csv)*/}
                                {/*    </button>*/}
                                {/*</CSVLink>*/}
                                <button className={styles.button} onClick={() => {
                                    const ws = utils.json_to_sheet(DataDevBox);
                                    const wb = utils.book_new();
                                    utils.book_append_sheet(wb, ws, "SheetJS");
                                    /* generate XLSX file and send to client */
                                    writeFile(wb, "export-datatable.xlsx");
                                }} style={{float: 'right'}}>
                                    <img src={downloadImg} style={{float: 'right'}} width={15}/> Download data
                                </button>
                                <br/>
                                <br/>
                                <div className={styles.main}>
                                    <DataTable
                                        columns={columns}
                                        // @ts-ignore
                                        customStyles={customStyles}
                                        paginationPerPage={20}
                                        paginationRowsPerPageOptions={[10,20,30,50,100]}
                                        defaultSortFieldId="venture"
                                        data={dataTable}
                                        // @ts-ignore
                                        rowKey='id'
                                        //expandableRows
                                        noDataComponent={<div style={{padding:"100px"}}>No records found</div>}
                                        highlightOnHover
                                        striped
                                        // subHeader
                                        // subHeaderAlign={"right"}
                                        // subHeaderWrap
                                        pagination={true}
                                        // paginationComponentOptions={paginationComponentOptions}
                                        fixedHeader={true}
                                        fixedHeaderScrollHeight={"800px"}
                                        // expandOnRowClicked={true}
                                        // expandableRowsComponent={ExpandableRowComponent}
                                    />
                                </div>
                            </ul>
                            :
                            <>
                                <button onClick={handleClickTable}>
                                    <h2><span style={{fontFamily: "consola",fontSize:30,color:"#007476"}}>+</span><span> &nbsp; Datatable ventures </span></h2>
                                </button>
                            </>
                        }
                    </div>
                }
            </div>
        </div>
    )
};



